import { collect } from '@/modules/Collect/helper';

export enum HelpDocsSource {
  /** 用户头像下拉菜单里的 Help Center */
  DropdownMenu = 'dropdown_menu',
  /** Settings 弹窗侧边栏里的 Help Center */
  SettingsSide = 'settings_side',
  /** 自定义域名输入页的 setup guide */
  CustomDomainInput = 'custom_domain_input',
  /** 自定义域名 DNS 配置页错误提示里的帮助文档 */
  CustomDomainDnsError = 'custom_domain_dns_error',
  /** 自定义域名 DNS 配置页服务商配置卡片里的教程 */
  CustomDomainConnect = 'custom_domain_connect',
  /** Wegic Cloud 设置页提示条里的 Learn More */
  WegicCloudWarning = 'wegic_cloud_warning',
  /** Wegic Cloud 预览遮罩里的 Read More */
  WegicCloudOverlay = 'wegic_cloud_overlay',
  /** Site Audit 面板里的 Google Search Console 引导 */
  SiteAuditGsc = 'site_audit_gsc',
}

export interface OpenHelpDocsOptions {
  source: HelpDocsSource;
  usage?: string;
  provider?: string;
  target?: string;
  features?: string;
}

export function openHelpDocs(url: string, options: OpenHelpDocsOptions) {
  const {
    source,
    usage,
    provider,
    target = '_blank',
    features = 'noopener,noreferrer',
  } = options;

  const properties: Record<string, unknown> = {
    source,
    url,
    open_type: target === '_blank' ? 'new_tab' : target,
  };

  if (usage) {
    properties.usage = usage;
  }
  if (provider) {
    properties.provider = provider;
  }

  collect('open_help_docs', properties);

  window.open(url, target, features);
}
